/** Shared column grid for the studies lobby list table (header + all row types). */
export const STUDY_LIST_TABLE_GRID_CLASS =
  "grid grid-cols-[minmax(0,1fr)_150px_176px_140px_120px_22px] items-center gap-x-3 px-4";

export const STUDY_LIST_TABLE_HEADER_CLASS = `${STUDY_LIST_TABLE_GRID_CLASS} border-b border-border/70 py-2 text-[14px] font-normal tracking-normal text-muted-foreground`;

export const STUDY_LIST_TABLE_ROW_CLASS = `${STUDY_LIST_TABLE_GRID_CLASS} border-b border-border/70 py-2 transition-colors`;
